import { Injectable } from '@angular/core';
import { UpdateIngestNodesStatusRequest } from '../messaging/updateIngestNodesStatusRequest';
import { UserDataService } from './user-data-service';
import { ConfigService } from './config/config.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateingestnodestatusService {

  constructor(private userData: UserDataService, private configService: ConfigService) { }

  async invokeUpdateIngestNodeStatus() {
      const selectedNodeDetails = this.userData.getSelectedNodeDetails();
      await this.updateIngestNodeStatus(selectedNodeDetails);
    }
  
    async updateIngestNodeStatus(selectedNode) {
      // const busyIndicator = this.showBusyDialog('Please wait...');
      var updateIngestNodesStatusRequest: UpdateIngestNodesStatusRequest = new UpdateIngestNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id )
      let updateIngestNodesStatusResponse = await this.configService.updateIngestNodeStatus(updateIngestNodesStatusRequest);
    } 
}
